import { createStoreModule } from '@/_core/fluxstore';
import { IAction } from '@/_core/fluxstore/types';
import { CsrfTokenDialogState } from './types';

const initState = () => {
    return new CsrfTokenDialogState();
};

export const useCsrfTokenDialogModule = createStoreModule<CsrfTokenDialogState, IAction<CsrfTokenDialogState>>(initState, 'app-csrf-token');
